<h3>Course results administration</h3>
               <hr />
               <button class="btn btn-primary pull-right" (click)="new()">Add new&nbsp;<span class="glyphicon glyphicon-plus"></span></button>
               <list-table [list]="results" [headers]="displayFields" [props]="props" [type]="type" (delete)="delete($event)"></list-table>